module.exports = __webpack_public_path__ + "static/media/icon-scheduling-day.a3d72402.svg";